import { useCallback } from 'react';
import { get } from 'lodash';

const useEventValueHandler = handler => useCallback(e => handler(get(e, 'target.value')), [handler]);

export default useEventValueHandler;
